module.exports = __webpack_public_path__ + "98e4d8b.worker.js"